import BaseOutlinedInput from '@material-ui/core/OutlinedInput'

const OutlinedInput = BaseOutlinedInput

export default OutlinedInput
